const handleUrlParameters = async () => {
    const urlParams = new URLSearchParams(window.location.search);

    const cityParam = urlParams.get('city');
    const workoutTypeParam = urlParams.get('workouttypes');
    const convenienceParam = urlParams.get('conveniences');

    if (!cityParam && !workoutTypeParam && !convenienceParam) return;

    let markersToFocus = findExerciseLocationMap.markers.filter(marker => {
        const markerCity = marker.content.getAttribute('data-city')?.toLowerCase() || '';

        const conveniencesRaw = marker.content.getAttribute('data-conveniences');
        const conveniences = conveniencesRaw ? JSON.parse(conveniencesRaw) : [];

        const workoutTypesRaw = marker.content.getAttribute('data-workouttypes');
        const workoutTypes = workoutTypesRaw ? JSON.parse(workoutTypesRaw) : [];

        const normalizedConveniences = conveniences.map(Number);
        const normalizedWorkoutTypes = workoutTypes.map(Number);

        const hasCityMatch = cityParam !== undefined
            ? markerCity === cityParam?.toLowerCase()
            : false;

        const hasWorkoutType = workoutTypeParam !== undefined
            ? normalizedWorkoutTypes.includes(Number(workoutTypeParam))
            : false;

        const hasConvenience = convenienceParam !== undefined
            ? normalizedConveniences.includes(Number(convenienceParam))
            : false;

        return hasCityMatch || hasWorkoutType || hasConvenience;
    });

    if (cityParam) {
        findExerciseLocationMap.savedInputValue = cityParam;
        const cityParamNormalized = cityParam.toLowerCase();
        markersToFocus = markersToFocus.filter(marker => {
            const markerCity = marker.content.getAttribute('data-city')?.toLowerCase();
            return markerCity === cityParamNormalized;
        });
    }

    if (findExerciseLocationMap.markers) {
        hideMarkers(markersToFocus);
    }
    // Adjust map bounds to fit the selected markers
    if (markersToFocus.length > 0) {
        adjustMapToFitMarkersUrl(markersToFocus);
    }
}
